import type { FinishKey, ModifierDef, ModifierKey } from '@wrapforce/shared';

// PLATFORM-DEFAULT modifier deltas, hardcoded from the seeded pricing_modifier_defs
// values in supabase/migrations/0014_pricing_engine_seed.sql — mirrors the same
// documented approach used for FINISH_LABELS in MaterialPicker.tsx (no
// GET /modifier-defs endpoint exists to fetch these client-side). Used ONLY for
// the live client-preview math below; the server's price-preview call and the
// save-time recompute resolver independently re-derive these from the DB
// (override-then-default), so a workspace override here would only affect the
// preview number shown, never what actually gets billed.
export const MODIFIER_DEFS: Record<ModifierKey, ModifierDef> = {
  side_skirts: { addedFtX10: 40, addedMinutes: 90 },
  front_splitter: { addedFtX10: 30, addedMinutes: 90 },
  front_lip: { addedFtX10: 20, addedMinutes: 60 },
  rear_diffuser: { addedFtX10: 30, addedMinutes: 90 },
  trunk_spoiler: { addedFtX10: 20, addedMinutes: 45 },
  fixed_wing: { addedFtX10: 30, addedMinutes: 75 },
  roof_spoiler: { addedFtX10: 15, addedMinutes: 30 },
  widebody_flares: { addedFtX10: 80, addedMinutes: 240 },
  vented_hood: { addedFtX10: 10, addedMinutes: 45 },
  complex_bumper: { addedFtX10: 20, addedMinutes: 120 },
  sensor_suite: { addedFtX10: 0, addedMinutes: 30 },
  flush_handles: { addedFtX10: 0, addedMinutes: 30 },
  roof_rails: { addedFtX10: 0, addedMinutes: 30 },
  running_boards: { addedFtX10: 0, addedMinutes: 45 },
  aftermarket_body_kit: { addedFtX10: 60, addedMinutes: 240 },
};

// Same hardcoding rationale as MODIFIER_DEFS above — mirrors
// supabase/migrations/0014_pricing_engine_seed.sql's finish_classes seed rows.
export const FINISH_DEFS = {
  gloss: { materialBp: 10000, laborBp: 10000, extraWasteBp: 0 },
  satin_matte: { materialBp: 11500, laborBp: 11000, extraWasteBp: 0 },
  metallic_pearl: { materialBp: 12000, laborBp: 10500, extraWasteBp: 0 },
  textured_directional: { materialBp: 13000, laborBp: 11500, extraWasteBp: 1500 },
  color_shift: { materialBp: 19000, laborBp: 12000, extraWasteBp: 1000 },
  chrome: { materialBp: 30000, laborBp: 19000, extraWasteBp: 2000 },
} satisfies Record<FinishKey, { materialBp: number; laborBp: number; extraWasteBp: number }>;
